declare global {
    interface Window { dataLayer: any; }
}

window.dataLayer = window.dataLayer || [];

import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { UserSessionService } from '../user-session/user-session.service';
import { CustomerModel } from 'src/app/models/customer-model';

@Injectable({
    providedIn: "root",
  })
export class MetapixelService {
    private curency;
    public fbq: any;
    private customer: CustomerModel;

    constructor(
        private config: ConfigService,
        private userSession: UserSessionService
    ) { 
        this.userSession.getCustomer().subscribe(
            (customer) => {
                if (customer) {
                    this.customer = customer;
                }
            }
        );
    }

    setup() {
        this.setupPixel();
    }

    private setupPixel() {
        let PixelKey = this.config.getPixelKey();
        if (PixelKey && PixelKey !== "") {
            const script = document.createElement('script');
            script.innerHTML = `!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');`;

            document.head.appendChild(script);

            const noScript = document.createElement('noscript');
            noScript.innerHTML = `<noscript><img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=${PixelKey}&ev=PageView&noscript=1"/></noscript>`;
            var s = document.body.firstChild;
            s.parentNode.insertBefore(noScript, s);

            // init Meta Pixel
            window['fbq']('init', PixelKey, {'external_id': ((!!this.customer) ? this.customer.customerId : "undefined")});
        }        
    }
   

    sendPageHistoryEvent(pageName) {
        let websiteUrl = document.location.origin;
        let virtualRoute = `${websiteUrl}/${pageName} `
        let data = {
            'event': 'Pageview',
            'url': virtualRoute
        }
        this.sendPixelEvent(data);
    }

    sendWebViewEvent() {
        let data = {
            'event': 'Pageview',
            'url': window.location.href
        }
        this.sendPixelEvent(data);
    }

    private sendPixelEvent(data) {
        if (window['fbq']) {
            //Trying to pass external_id as customerID
            //https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters

            window['fbq']('track', 'PageView', data);
        }        
    }

}